"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IVR_SUCCESS = exports.IVRErrorsType = void 0;
var IVRErrorsType;
(function (IVRErrorsType) {
    IVRErrorsType["KO_USER_ERROR"] = "KO_USER_ERROR";
    IVRErrorsType["KO_TECHNICAL_ERROR"] = "KO_TECHNICAL_ERROR";
    IVRErrorsType["KO_OTP_LIMIT"] = "KO_OTP_LIMIT";
})(IVRErrorsType || (exports.IVRErrorsType = IVRErrorsType = {}));
var IVR_SUCCESS;
(function (IVR_SUCCESS) {
    IVR_SUCCESS["SUCCESS"] = "SUCCESS";
})(IVR_SUCCESS || (exports.IVR_SUCCESS = IVR_SUCCESS = {}));
//# sourceMappingURL=ivrModel.js.map